import React, { ComponentType } from "react";
import { SafeAreaProvider, SafeAreaView } from "react-native-safe-area-context";

export const withSafeArea = (Component: ComponentType): ComponentType => {
  return () => {
    return (
      <SafeAreaProvider>
        <SafeAreaView style={{ flex: 1 }}>
          <Component />
        </SafeAreaView>
      </SafeAreaProvider>
    );
  };
};
